export const TOUR_LEADER_CHAT_IMAGE_TYPES = Object.freeze(['image/jpeg', 'image/png', 'image/webp'])
export const TOUR_LEADER_CHAT_IMAGE_MAX_BYTES = 5 * 1024 * 1024

export function validateTourLeaderChatImage(file) {
  if (!file || !TOUR_LEADER_CHAT_IMAGE_TYPES.includes(file.type)) {
    throw new Error('僅支援 JPEG、PNG 或 WebP 圖片')
  }
  if (!Number.isFinite(file.size) || file.size <= 0) {
    throw new Error('圖片內容不完整')
  }
  if (file.size > TOUR_LEADER_CHAT_IMAGE_MAX_BYTES) {
    throw new Error('圖片大小不可超過 5 MB')
  }
  return file
}

export function protectedMediaBody(response) {
  const body = response && response.__httpResponse ? response.body : response
  if (!(body instanceof Blob) || !TOUR_LEADER_CHAT_IMAGE_TYPES.includes(body.type)) {
    throw new Error('伺服器回傳的圖片格式不正確')
  }
  return body
}

export function revokeProtectedMediaUrls(
  mediaUrls,
  revokeObjectURL = url => URL.revokeObjectURL(url)
) {
  Object.values(mediaUrls || {}).forEach(url => {
    if (url) revokeObjectURL(url)
  })
}
